import { PAGE_TYPE_SHOPPING_CART } from 'cart/constants/constants'
import type { ProductType } from 'cart/hooks/mutations/useAddToCart'
import { useCartController } from 'cart/hooks/useCartController'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductStock } from 'product/services/productStock/client'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useProductCardStock } from 'product-card/hooks/useProductCardStock'
import { appsAddToBag } from 'product-card/utils/appsAddToBag/appsAddToBag'
import type { SelectedSize } from 'product-components/components/SizeSelector/SizesList/SizesList'
import { useCallback } from 'react'
import type { PlpDomainData } from 'types/masterData/domainData/domainData'

const productSeller = 'mango'

export function useAddSelectedSize({
	opened = false,
}: Readonly<{
	opened?: boolean
}>) {
	const {
		isApp,
		custom,
		pageType,
		country: { countryISO },
	} = useMasterData()
	const { layoutView } = useProductCardConsumerLayoutContext()
	const {
		productId,
		productColors,
		selectedColorId,
		lookId,
		location,
		productListId,
		onAddToCart,
	} = useProductCard()
	const isCartPage = pageType === PAGE_TYPE_SHOPPING_CART
	const { add } = useCartController({ isCartPage })

	const { data: productStock } = useProductStock({
		productId,
		country: countryISO,
		enabled: !!opened,
	})

	const { productSizesFullInfo } = useProductCardStock({
		productStock,
		productColors,
	})

	const onAdd = useCallback(
		(selected: SelectedSize) => {
			const productType: ProductType = {
				productId,
				layoutView,
				look: lookId,
				sizeId: selected.size.id,
				seller: productSeller,
				colorId: selected.color,
				lastUnits: !!productSizesFullInfo?.[0]?.lastUnits,
			}

			if (isApp) {
				appsAddToBag(
					productId,
					selectedColorId,
					lookId,
					custom as PlpDomainData
				)
			} else {
				void add(productType, location, productListId)
			}

			if (onAddToCart) {
				onAddToCart()
			}
		},
		[
			add,
			custom,
			isApp,
			layoutView,
			location,
			lookId,
			onAddToCart,
			productId,
			productListId,
			productSizesFullInfo,
			selectedColorId,
		]
	)

	return {
		onAdd,
	}
}
